module.exports = __webpack_public_path__ + "images/avatars/female/16.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/avatars/female/16.svg
// module id = CFmk
// module chunks = 118